import {
  CreateHisAppointmentRequest,
  CreateManualAppointmentRequest,
} from "@shared/dtos/requests/appointmentRequests.dto"
import { PageRequest } from "@shared/dtos/requests/pageRequest.dto"
import {
  AgendaSlotsResponse,
  AppointmentDetailResponse,
  AppointmentPageResponse,
} from "@shared/dtos/responses/appointmentResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getSlots = (practiceId: string): Promise<AgendaSlotsResponse[]> => {
  return axiosAuth({
    url: `/appointments/slots/${practiceId}`,
    method: "get",
  }).then((resp) => resp.data)
}

export const findAll = (query?: PageRequest): Promise<AppointmentPageResponse> => {
  return axiosAuth({
    url: "/appointments",
    method: "get",
    params: query,
  }).then((resp) => resp.data)
}

export const getById = (appointmentId: string): Promise<AppointmentDetailResponse> => {
  return axiosAuth({
    url: `/appointments/${appointmentId}`,
    method: "get",
  }).then((resp) => resp.data)
}

export const addInHis = (data: CreateHisAppointmentRequest): Promise<void> => {
  return axiosAuth({
    url: "/appointments/his",
    method: "post",
    data,
  }).then(() => undefined)
}

export const addManually = (data: CreateManualAppointmentRequest): Promise<void> => {
  return axiosAuth({
    url: "/appointments/manual",
    method: "post",
    data,
  }).then(() => undefined)
}

export const remove = (appointmentId: string): Promise<void> => {
  return axiosAuth({
    url: `/appointments/${appointmentId}`,
    method: "delete",
  }).then(() => undefined)
}
